/* CILSON – mitlaufende Kaufleiste auf der Produktseite (Handy) */
(() => {
  if (window.cilsonPdpSbar) return;
  window.cilsonPdpSbar = true;

  // Mitlaufende Kaufleiste (Handy)
  const stickyBar = () => {
    if (document.querySelector('.cil-sbar')) return;
    const main = document.querySelector('.product__info-container .product-form__submit');
    if (!main || main.disabled) return;
    const titleEl = document.querySelector('.product__info-container .product__title h1, .product__info-container h1');
    const title = ((titleEl && titleEl.textContent) || '').trim().split(' – ')[0];
    const bar = document.createElement('div');
    bar.className = 'cil-sbar';
    bar.innerHTML = '<div class="cil-sbar-info"><div class="cil-sbar-t"></div><div class="cil-sbar-p"></div></div>' +
      '<button type="button" class="cil-sbar-btn">In den Warenkorb</button>';
    bar.querySelector('.cil-sbar-t').textContent = title;
    bar.setAttribute('aria-hidden', 'true');
    document.body.appendChild(bar);
    const priceEl = bar.querySelector('.cil-sbar-p');
    const paint = () => {
      const q = parseInt((document.querySelector('.product__info-container input[name="quantity"]') || {}).value, 10) || 1;
      const total = document.querySelector('.cil-nb-sum-r2 b');
      const unit = document.querySelector('.cil-nb-line1 b');
      const html = q > 1 && total
        ? total.textContent.trim() + ' <small>(' + q + ' St.)</small>'
        : ((unit && unit.textContent.trim()) || '') + ' <small>/ St.</small>';
      if (priceEl.innerHTML !== html) priceEl.innerHTML = html;
    };
    paint();
    setInterval(paint, 800);
    bar.querySelector('.cil-sbar-btn').addEventListener('click', () => main.click());
    const set = (on) => {
      if (window.innerWidth >= 750) on = false;
      bar.classList.toggle('an', on);
      bar.setAttribute('aria-hidden', String(!on));
      document.body.classList.toggle('cil-sbar-on', on);
    };
    if ('IntersectionObserver' in window) {
      new IntersectionObserver((en) => set(!en[0].isIntersecting), { threshold: 0 }).observe(main);
    }
  };

  const start = () => {
    stickyBar();
    [600, 1500, 3000].forEach((ms) => setTimeout(stickyBar, ms));
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
